import React from 'react'

const PaymentOptionsTextBulgarian = ()=> {
  return(
   <div className="terms-text">
      <h2>Плащане на поръчка</h2>
      <p>
        В нашата компания полагаме всички усилия да предоставим най-доброто обслужване на нашите клиенти. Затова сме включили възможно най-много начини на плащане.
      </p>    
      <h2>
        Кредитна карта – Дебитна карта
      </h2>
      <p>
        В нашия магазин приемаме кредитни, дебитни и предплатени карти на всички банки. При плащане във физическия ни магазин, плащането се извършва чрез POS терминал. При покупка от онлайн магазина и плащане с кредитна карта, потребителят се пренасочва към сигурната среда на партньорската банкова организация (Viva, PayPal). Този уебсайт е сигурен и защитен със SSL сертификат. Данните за кредитната, дебитната или предплатената карта, която ще се използва, не се разкриват пред нас и ние не ги съхраняваме в компанията.
      </p>
      <h2>
        Вземане от магазина
      </h2>
      <p>
        Ако изберете да вземете продуктите си от магазина, плащането на сумата от поръчката се извършва на място.
      </p>
    </div>
  )
}
    
export default PaymentOptionsTextBulgarian;